module.exports = __webpack_public_path__ + "img/sleep-inn-logo.29fa6d01.jpg";